import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiPortalPricing = createApi({
  reducerPath: 'apiPortalPricing',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_PORTAL_PRICING_API,
    prepareHeaders: headers => {
      headers.set('x-api-key', process.env.ENV_PORTAL_PRICING_API_KEY || '');
      headers.set('Content-Type', 'application/json');
      headers.set('Env-Origin', process.env.ENV_ORIGIN || 'qa');
      return headers;
    },
  }),
  endpoints: () => ({}),
});

export const apiApproverPortal = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.ENV_APPROVER_API_URL,
    prepareHeaders: headers => {
      headers.set('x-api-key', process.env.ENV_APPROVER_API_KEY || '');
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'apiApproverPortal',
});

export const apiDocumentsPortal = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DOCUMENTS_API_URL,
    prepareHeaders: headers => {
      headers.set('x-api-key', process.env.REACT_APP_DOCUMENTS_API_KEY || '');
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  endpoints: () => ({}),
  reducerPath: 'apiDocumentsPortal',
  tagTypes: ['ApproverTasks'],
});

export const apiOrchestratorPricingCommittee = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ORCHESTRATOR_GLOBAL_URL as string,
    prepareHeaders: headers => {
      headers.set(
        'x-api-key',
        process.env.REACT_APP_ORCHESTRATOR_GLOBAL_API_KEY as string
      );
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['CurrentOrchestrator'],
  endpoints: () => ({}),
  reducerPath: 'apiOrchestratorPricingCommittee',
});
